import React from 'react';

import { GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid-pro';

export default function CharterFlightsPricingToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  );
}
